
export enum SortDirection {
  none = '',
  asc = 'Ascending',
  desc = 'Descending'
}
